<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Atributos de Productos</h1>
      </div>
    </div>
    <div class="content__row">
      <attribute-list :filters="filters"></attribute-list>
      <attribute-view :attr="attribute" v-if="attrAction === 'view' && attribute"></attribute-view>
      <attribute-edit @new="newAttribute" :attr="attribute" v-if="attrAction === 'edit'" :key="key"></attribute-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'productView'}">Productos</router-link>
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
          <div class="form__container">
            <label class="form__label" for="type_id"> Filtrar por tipo de atributo</label>
            <div class="form__select-container">
              <select name="type_id" id="type_id" class="form__select" v-model="type_id" @change="setFilters">
                <option :value="null">Todos</option>
                <option v-for="(type, index) in types" :key="index" :value="type.id" v-text="type.name"></option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newAttribute" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import attributeList from './list'
import attributeView from './view'
import attributeEdit from './edit'
import Mixins from './mixins'
export default {
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    attributeList,
    attributeView,
    attributeEdit
  },
  data: function () {
    return {
      key: 0,
      search: null,
      type_id: null,
      filters: undefined,
      attrAction: null,
      attribute: null
    }
  },
  created: function () {
    this.getTypes()
  },
  mounted: function () {
    this.$on('view',id => {
      this.getAttribute(id, 'view')
    })
    this.$on('edit',id => {
      this.getAttribute(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = filter + '&search=' + this.search
      }
      if (this.type_id) {
        filter = filter + '&type_id=eq:' + this.type_id
      }
      filter = filter.replace(/(^&+|&+$)/, '')
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getAttribute: function (id, action) {
      this.attrAction = false
      let httpRequest = {
        params: '',
        module: 'attributes'
      }
      this.getById(id, httpRequest)
        .then(
          attribute => {
            this.attribute = attribute.data
            this.attrAction = action
          }
        )
    },
    newAttribute: function () {
      this.attribute = undefined
      this.key = ++this.key
      this.attrAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/attributes/attributes.vue